import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { groupingState } from '../../../recoil/atoms/grouping';
const useStyles = makeStyles((theme) => ({
  timeDropdown: {
    width: '100px',
    margin: 0,
    paddingTop: '5px',
  },
}));
export function TimeGrouping() {
  const route = useLocation();
  const classes = useStyles();
  const [grouping, setGrouping] = useRecoilState(groupingState);
  const routeBoolean =
    route.pathname.includes('agent-reports') ||
    route.pathname.includes('business-reports') ||
    route.pathname.includes('agent-reporting');
  return (
    <>
      {routeBoolean && (
        <div
          className="ml-auto"
          style={{
            paddingRight: '1vw',
          }}
        >
          <FormControl
            className={classes.timeDropdown}
            size="small"
            variant="outlined"
          >
            <InputLabel style={{ paddingTop: '7px' }}>Time Grouping</InputLabel>
            <Select
              value={grouping.grouping}
              onChange={(e) =>
                setGrouping({
                  grouping: e.target.value,
                })
              }
              label="Time Grouping"
              name="time-grouping"
            >
              <MenuItem value="Day">Day</MenuItem>
              <MenuItem value="Week">Week</MenuItem>
              <MenuItem value="Month">Month</MenuItem>
            </Select>
          </FormControl>
        </div>
      )}
    </>
  );
}
